import { HevyMenu, HevyMenuItem } from 'components/HevyMenu';
import React from 'react';
import { Icon } from 'styleguide/Icons';
import { zIndex } from 'styleguide/Modal';
import { t } from 'translations/t';

interface CommentOptionsMenuProps {
  onDeleteClick: () => void;
}

export const CommentOptionsMenu = ({ onDeleteClick }: CommentOptionsMenuProps) => (
  <HevyMenu
    direction="left"
    menuStyle={{ zIndex: zIndex.modalOverlay }}
    menuButton={
      <div style={{ display: 'flex', cursor: 'pointer' }}>
        <Icon type="horizontal-dots" />
      </div>
    }
  >
    <HevyMenuItem
      onClick={onDeleteClick}
      iconType="trash"
      title={t('web.workoutCell.comments.deleteComment')}
    />
  </HevyMenu>
);
